const BRANCH_CONTACTS = [
  {
    id: "samarkand",
    title: "navBranchSamarkand",
    phones: [
      {
        id: "samarkand-registration",
        label: "navPhoneRegistration",
        phone: "+998 (95) 410 00 14",
        href: "tel:+998954100014",
      },
    ],
  },
  {
    id: "xatirchi",
    title: "navBranchXatirchi",
    phones: [
      {
        id: "xatirchi-registration",
        label: "navPhoneRegistration",
        phone: "+998 (97) 921 00 14",
        href: "tel:+998979210014",
      },
    ],
  },
];

export default BRANCH_CONTACTS;
